import axios_nomura from './axios-nomura.services';
import axios from './axios-mock.services';

export const fetchBanners = async () => {
  return await axios_nomura.get(`api/v1/home/banners`);
};

export const fetchHighlightFunds = async () => {
  return await axios_nomura.get(`api/v1/home/hot_funds`);
};

export const fetchTopSubCategories = async () => {
  return await axios_nomura.get(`api/v1/home/category_rankings`);
};

export const fetchArticles = async () => {
  return await axios_nomura.get(`api/v1/home/article_categories`);
};
